import {
    IonApp,
    IonButton,
    IonCol,
    IonContent,
    IonGrid,
    IonIcon,
    IonInput,
    IonRow,
    IonSegment,
    IonSegmentButton,
    IonSlide,
    IonSlides,
    IonToolbar,
} from "@ionic/react";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Toolbar from "../../components/Toolbar";
import Firebase from "../../firebase";
import { REGEX } from "../../regex";
import { URLS } from "../../urls";
import "./style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Footer from "../../components/Footer";
import Avatar from "awesome-react-avataaars";
import { avatarOptions } from "../../avataaars";
import { chevronBack, chevronForward } from "ionicons/icons";

declare const window, document: any;

const avatarOptionsKeys = Object.keys(avatarOptions);

const SLIDES = [
    { url: "/nickname", label: "שינוי כינוי", needPass: false },
    { url: "/email", label: 'שינוי דוא"ל', needPass: true },
    { url: "/password", label: "שינוי סיסמה", needPass: true },
    { url: "/phone", label: "אימות טלפוני", needPass: false },
    { url: "/delete", label: "מחיקת חשבון", needPass: false },
];

const SMS_LENGTH = 6;

class Account extends Component {
    state = {
        fb: Firebase.getInstance(),
        user: {} as any,
        data: {} as any,
        phoneLinked: false,
        phone: "",
        needPass: true,
        slides: React.createRef<HTMLIonSlidesElement>() as any,
        avatar: {} as any,
    };

    _isMounted = true;

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        document.dispatchEvent(new Event("pageMount"));

        const user = await this.state.fb.getUser();
        const data = await this.state.fb.readData("users/public/$uid");
        if (!this._isMounted) return;
        const userProvidersIDs = await this.state.fb.userProvidersIDs();
        if (!userProvidersIDs.includes(this.state.fb.EmailAuthProvider)) this.setState({ needPass: false });

        const phoneProviderID = this.state.fb.phoneProviderID;
        const phoneLinked = userProvidersIDs.includes(phoneProviderID);

        this.setState({ user, data, phoneLinked, avatar: data.avatar ?? {} });

        const links: any = document.getElementsByClassName("account__link");
        for (let i = 0; i < links.length; i++) {
            if (links[i].pathname === window.location.pathname) links[i].firstElementChild.click();
        }

        if (!phoneLinked) {
            window.recaptchaVerifier = await this.state.fb.recaptchaVerifier("recaptcha-container");
        } else {
            this.setState({ phone: user.providerData[userProvidersIDs.indexOf(phoneProviderID)].uid });
        }
    }

    renderRedirect = () => {
        if (window.location.pathname.split("/").join("") === URLS.ACCOUNT.url.split("/").join(""))
            return <Redirect to={URLS.ACCOUNT.url + "/nickname"} />;
    };

    avatarForward = (key) => {
        const avatar = this.state.avatar;
        const arr = avatarOptions[key];
        console.log(key);
        console.log(avatarOptions);

        console.log(arr.indexOf(avatar[key]));

        this.setState({
            avatar: {
                ...avatar,
                ...{
                    [key]: arr[(arr.indexOf(avatar[key]) + 1) % arr.length],
                },
            },
        });
    };
    avatarBack = (key) => {
        const avatar = this.state.avatar;
        const arr = avatarOptions[key];
        console.log("back");

        this.setState({
            avatar: {
                ...avatar,
                ...{
                    [key]: arr[(arr.indexOf(avatar[key]) - 1 + arr.length) % arr.length],
                },
            },
        });
    };

    render() {
        return (
            <IonApp>
                {this.renderRedirect()}
                <Toolbar />
                <IonContent style={{ textAlign: "center" }}>
                    <IonToolbar className="account__toolbar">
                        <div style={{ overflowX: "scroll", overflow: "hidden" }}>
                            <IonSegment
                                scrollable={true}
                                value={window.location.pathname}
                                className="account__segment"
                            >
                                {SLIDES.map((slideValue: any, slideIndex) => {
                                    if (!slideValue.needPass || this.state.needPass)
                                        return (
                                            <Link
                                                key={"slide" + slideIndex}
                                                className="account__link"
                                                to={URLS.ACCOUNT.url + slideValue.url}
                                            >
                                                <IonSegmentButton
                                                    onClick={() => {
                                                        this.state.slides.current.slideTo(slideIndex);
                                                    }}
                                                >
                                                    {slideValue.label}
                                                </IonSegmentButton>
                                            </Link>
                                        );
                                })}
                            </IonSegment>
                        </div>
                    </IonToolbar>
                    <br />
                    <IonSlides
                        ref={this.state.slides}
                        options={{ allowTouchMove: false }}
                        style={{ height: "60vh" }}
                    >
                        <IonSlide className="account__slide">
                            <IonInput
                                id="accountNickname_nickname"
                                minlength={2}
                                maxlength={25}
                                placeholder="כינוי"
                                value={this.state.data.nickname}
                            />
                            <div className="account__changeAvatar">
                                <div style={{ display: "inline-block" }}>
                                    <IonGrid>
                                        {avatarOptionsKeys
                                            .slice(0, avatarOptionsKeys.length / 2)
                                            .map((key) => {
                                                return (
                                                    <IonRow key={key}>
                                                        <IonCol className="acount__avatarCol1">
                                                            <IonIcon
                                                                icon={chevronForward}
                                                                onClick={() => {
                                                                    this.avatarForward(key);
                                                                }}
                                                            />
                                                        </IonCol>
                                                        <IonCol className="acount__avatarCol2">
                                                            {this.state.avatar[key] ?? key}
                                                        </IonCol>
                                                        <IonCol className="acount__avatarCol1">
                                                            <IonIcon
                                                                icon={chevronBack}
                                                                onClick={() => {
                                                                    this.avatarBack(key);
                                                                }}
                                                            />
                                                        </IonCol>
                                                    </IonRow>
                                                );
                                            })}
                                    </IonGrid>
                                </div>
                                <Avatar
                                    avatarStyle="Circle"
                                    graphicType={this.state.avatar.graphicType}
                                    topType={this.state.avatar.topType}
                                    hatColor={this.state.avatar.hatColor}
                                    accessoriesType={this.state.avatar.accessoriesType}
                                    hairColor={this.state.avatar.hairColor}
                                    facialHairType={this.state.avatar.facialHairType}
                                    facialHairColor={this.state.avatar.facialHairColor}
                                    clotheType={this.state.avatar.clotheType}
                                    clotheColor={this.state.avatar.clotheColor}
                                    eyeType={this.state.avatar.eyeType}
                                    eyebrowType={this.state.avatar.eyebrowType}
                                    mouthType={this.state.avatar.mouthType}
                                    skinColor={this.state.avatar.skinColor}
                                />
                                <div style={{ display: "inline-block" }}>
                                    <IonGrid>
                                        {avatarOptionsKeys
                                            .slice(avatarOptionsKeys.length / 2, avatarOptionsKeys.length)
                                            .map((key) => {
                                                return (
                                                    <IonRow key={key}>
                                                        <IonCol className="acount__avatarCol1">
                                                            <IonIcon
                                                                icon={chevronForward}
                                                                onClick={() => {
                                                                    this.avatarForward(key);
                                                                }}
                                                            />
                                                        </IonCol>
                                                        <IonCol className="acount__avatarCol2">
                                                            {this.state.avatar[key] ?? key}
                                                        </IonCol>
                                                        <IonCol className="acount__avatarCol1">
                                                            <IonIcon
                                                                icon={chevronBack}
                                                                onClick={() => {
                                                                    this.avatarBack(key);
                                                                }}
                                                            />
                                                        </IonCol>
                                                    </IonRow>
                                                );
                                            })}
                                    </IonGrid>
                                </div>
                            </div>
                            <br />
                            <IonButton
                                onClick={async () => {
                                    const nickname = document.getElementById("accountNickname_nickname")
                                        .value;
                                    if (nickname && nickname !== this.state.data.nickname)
                                        await this.state.fb.setUserData(nickname);
                                    await this.state.fb.updateData(
                                        "users/public/$uid/avatar",
                                        this.state.avatar
                                    );
                                    window.location.pathname = "/";
                                }}
                            >
                                עדכון
                            </IonButton>
                        </IonSlide>
                        <IonSlide className="account__slide">
                            <div style={{ fontWeight: "bold" }}>דוא"ל נוכחי</div>
                            <div>{this.state.user.email}</div>
                            <br />
                            <IonInput
                                type="email"
                                id="accountEmail_email"
                                placeholder='דוא"ל חדש'
                                pattern={REGEX.email}
                            />
                            <br />
                            <IonInput
                                type="password"
                                id="accountEmail_pass"
                                placeholder="סיסמה"
                                pattern={REGEX.password}
                            />
                            <br />
                            <IonButton
                                onClick={async () => {
                                    const email = document.getElementById("accountEmail_email").value;
                                    const pass = document.getElementById("accountEmail_pass").value;
                                    if (email && email !== this.state.user.email) {
                                        await this.state.fb.updateEmail(email, pass);
                                        window.location.pathname = "/";
                                    }
                                }}
                            >
                                עדכון
                            </IonButton>
                        </IonSlide>
                        <IonSlide className="account__slide">
                            <IonInput
                                type="password"
                                id="accountPass_oldPass"
                                placeholder="סיסמה ישנה"
                                pattern={REGEX.password}
                            ></IonInput>
                            <br />
                            <IonInput
                                type="password"
                                id="accountPass_newPass"
                                placeholder="סיסמה חדשה"
                                pattern={REGEX.password}
                            ></IonInput>
                            <br />
                            <IonInput
                                type="password"
                                id="accountPass_newPass2"
                                placeholder="סיסמה חדשה שוב"
                                pattern={REGEX.password}
                            ></IonInput>
                            <br />
                            <IonButton
                                onClick={async () => {
                                    const oldPass = document.getElementById("accountPass_oldPass").value;
                                    const newPass = document.getElementById("accountPass_newPass").value;
                                    const newPass2 = document.getElementById("accountPass_newPass2").value;
                                    if (oldPass && newPass && newPass === newPass2) {
                                        await this.state.fb.updatePassword(oldPass, newPass);
                                        window.location.pathname = "/";
                                    }
                                }}
                            >
                                עדכון
                            </IonButton>
                        </IonSlide>
                        <IonSlide id="accountPhone" className="account__slide">
                            <div id="accountPhone_topPart">
                                <div className="accountPhone_phoneDiv">
                                    {this.state.phoneLinked ? (
                                        <div>חשבונך מאומת באמצעות הטלפון</div>
                                    ) : (
                                        <div>קוד אימות ישלח לטלפון שהוזן</div>
                                    )}
                                    <br />
                                    <PhoneInput
                                        country={"il"}
                                        disabled={this.state.phoneLinked}
                                        placeholder="972 05X XXX XXXX"
                                        value={this.state.phone}
                                        buttonClass={this.state.phoneLinked ? "flagBtnDisabled" : ""}
                                        onChange={(phone) => this.setState({ phone })}
                                    />
                                </div>
                                <br />
                                {this.state.phoneLinked ? (
                                    <IonButton
                                        className="account__delete_btn"
                                        onClick={async () => {
                                            await this.state.fb.unlinkProvider(this.state.fb.phoneProviderID);
                                            window.location.pathname = "/";
                                        }}
                                    >
                                        ביטול שיוך לחשבון
                                    </IonButton>
                                ) : (
                                    <div>
                                        <div
                                            id="recaptcha-container"
                                            style={{
                                                width: "min-content",
                                                marginRight: "auto",
                                                marginLeft: "auto",
                                            }}
                                        ></div>
                                        <br />
                                        <IonButton
                                            id="updatePhoneBtn"
                                            onClick={async () => {
                                                if (
                                                    this.state.phone.length > 14 ||
                                                    this.state.phone.length < 10 ||
                                                    window.grecaptcha.getResponse().length === 0
                                                )
                                                    return;
                                                var appVerifier = window.recaptchaVerifier;
                                                window.confirmationResult = await this.state.fb.linkPhone(
                                                    "+" + this.state.phone,
                                                    appVerifier
                                                );
                                                if (window.confirmationResult.message) {
                                                    alert(window.confirmationResult.message);
                                                } else {
                                                    document
                                                        .getElementById("accountPhone_topPart")
                                                        .classList.add("moveUp_top");
                                                    document
                                                        .getElementById("accountPhone_bottomPart")
                                                        .classList.add("moveUp_bottom");
                                                    setTimeout(() => {
                                                        document
                                                            .getElementsByClassName(
                                                                "accountPhone_smallInput"
                                                            )[0]
                                                            .setFocus();
                                                    }, 1000);
                                                }
                                            }}
                                        >
                                            עדכון
                                        </IonButton>
                                    </div>
                                )}
                            </div>
                            <div id="accountPhone_bottomPart" style={{ direction: "ltr" }}>
                                <div>קוד אימות נשלח לטלפון שהוזן</div>
                                <br />
                                {Array.from(Array(SMS_LENGTH).keys()).map((num) => {
                                    return (
                                        <IonInput
                                            key={"input" + num}
                                            className="accountPhone_smallInput"
                                            min="0"
                                            max="9"
                                            type="tel"
                                            onKeyDown={async (e: any) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                const inputs = document.getElementsByClassName(
                                                    "accountPhone_smallInput"
                                                );
                                                setTimeout(() => {
                                                    if (isNaN(parseInt(inputs[num].value)))
                                                        inputs[num].value = "";
                                                }, 0);
                                                if (isNaN(parseInt(e.key)) && e.key !== "Backspace") return;
                                                if (!isNaN(parseInt(e.key))) {
                                                    inputs[num].value = e.key;
                                                    if (num !== SMS_LENGTH - 1) {
                                                        inputs[num + 1].setFocus();
                                                    }
                                                } else if (num !== 0) {
                                                    if (inputs[num].value !== "") {
                                                        inputs[num].value = "";
                                                    } else {
                                                        inputs[num - 1].value = "";
                                                        inputs[num - 1].setFocus();
                                                    }
                                                }
                                                var code = "";
                                                for (let i = 0; i < inputs.length; i++) {
                                                    code += inputs[i].value;
                                                }
                                                if (code.length === SMS_LENGTH) {
                                                    const res = await this.state.fb.linkPhoneCheckCode(
                                                        window.confirmationResult,
                                                        code
                                                    );
                                                    if (res.message) {
                                                        alert("קוד שגוי");
                                                    } else window.location.pathname = "/";
                                                }
                                            }}
                                        />
                                    );
                                })}
                            </div>
                        </IonSlide>
                        <IonSlide className="account__slide">
                            <div style={{ display: this.state.needPass ? "block" : "none" }}>
                                <IonInput
                                    type="password"
                                    id="accountDelete_pass"
                                    placeholder="סיסמה"
                                    pattern={REGEX.password}
                                />
                                <br />
                                <IonInput
                                    type="password"
                                    id="accountDelete_pass2"
                                    placeholder="סיסמה שוב"
                                    pattern={REGEX.password}
                                />
                            </div>
                            <br />
                            <IonButton
                                className="account__delete_btn"
                                onClick={async () => {
                                    const pass = document.getElementById("accountDelete_pass").value;
                                    const pass2 = document.getElementById("accountDelete_pass2").value;
                                    if (pass === pass2) {
                                        if (
                                            !window.confirm(
                                                "בטוח שברצונך למחוק את החשבון? לאחר ביצוע הפעולה לא יהיה ניתן לשחזרו"
                                            )
                                        )
                                            return;
                                        await this.state.fb.deleteUser(pass);
                                    }
                                }}
                            >
                                מחיקת חשבון
                            </IonButton>
                        </IonSlide>
                    </IonSlides>
                    <br />
                    <Footer />
                </IonContent>
            </IonApp>
        );
    }
}

export default Account;
